// ---------------------------------------------
// auto-generated from screens/flash.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { Icon, Chip, Eyebrow, ObjectiveBar, StatusBar, Candles, genCandles, NotAdvice } from "./primitives.jsx";

// Shared dataset for the Flash piece
export const FLASH_DATA = () => genCandles(28, 11, { trend: 0.9, vol: 1.4, base: 100 });

// shared chrome
export const FlashTopChips = ({ live = true }) => (
  <div style={{
    position: "absolute", top: 56, left: 16, right: 16,
    display: "flex", alignItems: "center", gap: 6, zIndex: 5
  }}>
    <Chip>EDU · FLASH · 20s</Chip>
    <Chip variant="neutral">iniciación</Chip>
    {live && <Chip variant="live">live case</Chip>}
  </div>
);

export const FlashProgress = ({ act = 3 }) => {
  const states = ["done", "done", act === 3 ? "on" : (act > 3 ? "done" : ""), act >= 4 ? (act === 4 ? "on" : "done") : "", act === 5 ? "on" : ""];
  return (
    <div className="dots" style={{ position: "absolute", top: 36, left: 0, right: 0, justifyContent: "center" }}>
      {[0,1,2,3,4].map(i => <i key={i} className={i < act - 1 ? "done" : i === act - 1 ? "on" : ""}/>)}
    </div>
  );
};

export const FlashPlayerControls = () => (
  <div style={{
    position: "absolute", bottom: 130, left: 0, right: 0,
    display: "flex", justifyContent: "center", gap: 14, zIndex: 6
  }}>
    <button className="icon-btn"><Icon name="cc" size={16}/></button>
    <button className="icon-btn primary" style={{ width: 56, height: 56, borderRadius: 99, background: "rgba(127,182,255,0.18)" }}>
      <Icon name="pause" size={20}/>
    </button>
    <button className="icon-btn"><Icon name="freeze" size={16}/></button>
  </div>
);

export const FlashBottomRail = ({ note = true }) => (
  <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}>
    <div style={{
      padding: "0 18px 10px",
      display: "flex", justifyContent: "space-between", alignItems: "center"
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span className="mono" style={{ fontSize: 10, color: "var(--text-3)", letterSpacing: "0.08em" }}>
          <Icon name="link" size={11} style={{ verticalAlign: "-2px", marginRight: 4, color: "var(--text-3)" }}/>
          vendor_primary · 14:32 UTC
        </span>
      </div>
      <div style={{ display: "flex", gap: 6 }}>
        <button className="icon-btn" style={{ width: 28, height: 28, borderRadius: 6 }}><Icon name="book" size={12}/></button>
        <button className="icon-btn" style={{ width: 28, height: 28, borderRadius: 6 }}><Icon name="headset" size={12}/></button>
      </div>
    </div>
    {note && (
      <div style={{
        height: 36, display: "flex", alignItems: "center", justifyContent: "center",
        borderTop: "1px solid var(--line)", background: "rgba(6,15,34,0.5)"
      }}>
        <NotAdvice>Educativo · No es asesoramiento</NotAdvice>
      </div>
    )}
  </div>
);

// ─────────────────────────────────────────────────────────
//  1. Flash / MobileReel / Player  · A3 evidence
// ─────────────────────────────────────────────────────────
export const ScreenFlashPlayer = () => {
  const data = React.useMemo(FLASH_DATA, []);
  return (
    <div className="screen-m ef" data-screen-label="Flash · Player · A3">
      <StatusBar/>
      <FlashTopChips/>
      <FlashProgress act={3}/>

      {/* Objective (eyebrow) */}
      <div style={{ position: "absolute", top: 100, left: 18, right: 18, zIndex: 4 }}>
        <ObjectiveBar eye="Objetivo">
          Identificar una tendencia por estructura, no por una vela
        </ObjectiveBar>
      </div>

      {/* Host visual — chart big */}
      <div style={{ position: "absolute", top: 200, left: 18, right: 18, zIndex: 2 }}>
        <div className="glass" style={{ padding: 0, overflow: "hidden", borderRadius: 16 }}>
          <div style={{ padding: "10px 12px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div className="mono" style={{ fontSize: 10.5, color: "var(--text-3)", letterSpacing: "0.08em" }}>XYZ · 1D · últimas 28 sesiones</div>
            <Chip variant="neutral">A3 · evidencia</Chip>
          </div>
          <Candles
            data={data} width={354} height={210} padding={8}
            overlays={[
              { type: "swing", x: 6, y: data[6].l - 0.6, label: "HL" },
              { type: "swing", x: 14, y: data[14].l - 0.6, label: "HL" },
              { type: "swing", x: 21, y: data[21].h + 1, label: "HH" },
            ]}/>
        </div>
      </div>

      {/* Caption */}
      <div style={{ position: "absolute", top: 470, left: 18, right: 18, zIndex: 4 }}>
        <div style={{ fontSize: 22, fontWeight: 600, lineHeight: 1.15, letterSpacing: "-0.02em", textWrap: "balance" }}>
          Una tendencia deja máximos
          <br/>
          <span style={{ color: "var(--accent)" }}>y mínimos cada vez más altos.</span>
        </div>
        <div style={{ fontSize: 13, color: "var(--text-2)", marginTop: 10, lineHeight: 1.4, textWrap: "pretty" }}>
          Mira la <span style={{ color: "var(--accent)" }}>secuencia</span>, no una sola vela.
        </div>
      </div>

      <FlashPlayerControls/>
      <FlashBottomRail/>
    </div>
  );
};

// ─────────────────────────────────────────────────────────
//  2. Flash / Microaction (tap-select)
// ─────────────────────────────────────────────────────────
export const ScreenFlashMicroaction = () => {
  const data = React.useMemo(FLASH_DATA, []);
  return (
    <div className="screen-m ef" data-screen-label="Flash · Microaction">
      <StatusBar/>
      <FlashTopChips/>
      <FlashProgress act={5}/>

      {/* Frozen frame */}
      <div style={{ position: "absolute", top: 100, left: 18, right: 18, zIndex: 4 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Chip variant="warn">microacción</Chip>
          <span className="mono" style={{ fontSize: 10, color: "var(--text-3)" }}>congelado · 00:17</span>
        </div>
        <div style={{ fontSize: 22, fontWeight: 600, lineHeight: 1.18, letterSpacing: "-0.02em", marginTop: 10, textWrap: "balance" }}>
          Toca el <span style={{ color: "var(--accent)" }}>mínimo creciente</span> que mantiene la tendencia.
        </div>
      </div>

      {/* Chart with tap targets */}
      <div style={{ position: "absolute", top: 260, left: 18, right: 18, zIndex: 2 }}>
        <div className="glass" style={{ borderRadius: 16, padding: 0, overflow: "hidden", position: "relative" }}>
          <div style={{ padding: "10px 12px", display: "flex", justifyContent: "space-between" }}>
            <span className="mono" style={{ fontSize: 10.5, color: "var(--text-3)" }}>4 candidatos</span>
            <span style={{ display: "flex", gap: 4 }}>
              <span className="kbd">1</span><span className="kbd">2</span><span className="kbd">3</span><span className="kbd">4</span>
            </span>
          </div>
          <div style={{ position: "relative" }}>
            <Candles data={data} width={354} height={260} padding={8}/>
            {/* Tap targets at 4 swings */}
            {[
              { i: 3, isLow: true, label: "1" },
              { i: 9, isLow: true, label: "2", glow: true },
              { i: 16, isLow: true, label: "3" },
              { i: 23, isLow: true, label: "4" },
            ].map((s, k) => {
              const min = Math.min(...data.map(d => d.l));
              const max = Math.max(...data.map(d => d.h));
              const span = max - min || 1;
              const w = (354 - 16) / data.length;
              const x = 8 + s.i * w + w / 2;
              const py = data[s.i].l;
              const y = 8 + (1 - (py - min) / span) * (260 - 16) + 8;
              return (
                <div key={k} style={{
                  position: "absolute",
                  left: x - 22, top: y - 22, width: 44, height: 44,
                  borderRadius: 99,
                  border: `1.5px solid ${s.glow ? "var(--accent)" : "rgba(127,182,255,0.55)"}`,
                  background: s.glow ? "rgba(95,214,193,0.16)" : "rgba(127,182,255,0.10)",
                  display: "grid", placeItems: "center",
                  boxShadow: s.glow ? "0 0 24px rgba(95,214,193,0.45)" : "none",
                }}>
                  <span className="mono" style={{ fontSize: 11, color: s.glow ? "var(--accent)" : "var(--primary)" }}>{s.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Secondary actions */}
      <div style={{ position: "absolute", bottom: 168, left: 18, right: 18, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn ghost sm" style={{ height: 32 }}><Icon name="lightbulb" size={13}/> Pista <span style={{ color: "var(--text-3)" }}>1/3</span></button>
          <button className="btn ghost sm" style={{ height: 32 }}><Icon name="retry" size={13}/></button>
        </div>
        <button className="btn ghost sm" style={{ height: 32 }}><Icon name="help" size={13}/> Tutor</button>
      </div>

      <FlashBottomRail/>
    </div>
  );
};

// ─────────────────────────────────────────────────────────
//  3. Flash / FeedbackCorrect
// ─────────────────────────────────────────────────────────
export const ScreenFlashCorrect = () => {
  const data = React.useMemo(FLASH_DATA, []);
  return (
    <div className="screen-m ef" data-screen-label="Flash · FeedbackCorrect">
      <StatusBar/>
      <FlashTopChips/>
      <FlashProgress act={5}/>

      {/* Header positive */}
      <div style={{ position: "absolute", top: 96, left: 0, right: 0, padding: "0 18px", zIndex: 4 }}>
        <div style={{
          background: "linear-gradient(180deg, rgba(95,214,193,0.18) 0%, rgba(95,214,193,0.04) 100%)",
          border: "1px solid rgba(95,214,193,0.32)",
          borderRadius: 16, padding: "16px 16px 18px"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <div style={{ width: 28, height: 28, borderRadius: 99, background: "var(--accent)", color: "#06241f", display: "grid", placeItems: "center" }}>
              <Icon name="check" size={16}/>
            </div>
            <div className="mono" style={{ fontSize: 11, letterSpacing: "0.14em", color: "var(--accent)", textTransform: "uppercase" }}>Correcto</div>
          </div>
          <div style={{ fontSize: 19, fontWeight: 600, lineHeight: 1.25, letterSpacing: "-0.01em", textWrap: "balance" }}>
            Has mirado <span style={{ color: "var(--accent)" }}>estructura</span>, no color de vela.
          </div>
          <div style={{ fontSize: 12.5, color: "var(--text-2)", marginTop: 6, lineHeight: 1.4 }}>
            La tendencia se sostiene en mínimos crecientes, no en una vela aislada.
          </div>
        </div>
      </div>

      {/* Chart with HL highlighted */}
      <div style={{ position: "absolute", top: 290, left: 18, right: 18 }}>
        <div className="glass" style={{ borderRadius: 14, overflow: "hidden" }}>
          <Candles data={data} width={354} height={170} padding={8}
            overlays={[
              { type: "swing", x: 9, y: data[9].l - 0.6, label: "HL" },
            ]}/>
        </div>
      </div>

      {/* Next step */}
      <div style={{ position: "absolute", top: 480, left: 18, right: 18 }}>
        <Eyebrow>Siguiente paso recomendado</Eyebrow>
        <div className="glass" style={{ marginTop: 8, padding: 14, borderRadius: 14, display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 38, height: 38, borderRadius: 10, background: "rgba(127,182,255,0.18)", display: "grid", placeItems: "center" }}>
            <Icon name="movie" size={16} style={{ color: "var(--primary)" }}/>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 600 }}>Multi-timeframe</div>
            <div className="mono" style={{ fontSize: 10, color: "var(--text-3)", marginTop: 2 }}>EXPLICA · 6 min</div>
          </div>
          <Icon name="next" size={18} style={{ color: "var(--text-3)" }}/>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
          <button className="btn ghost sm" style={{ flex: 1 }}><Icon name="save" size={13}/> Guardar repaso</button>
          <button className="btn ghost sm" style={{ flex: 1 }}><Icon name="share" size={13}/> Compartir clip</button>
        </div>
      </div>

      <div style={{ position: "absolute", bottom: 88, left: 18, right: 18 }}>
        <button className="btn primary" style={{ width: "100%" }}>
          <Icon name="next" size={14}/> Siguiente flash
        </button>
      </div>
      <FlashBottomRail note={true}/>
    </div>
  );
};

// ─────────────────────────────────────────────────────────
//  4. Flash / FeedbackIncorrect
// ─────────────────────────────────────────────────────────
export const ScreenFlashIncorrect = () => {
  const data = React.useMemo(FLASH_DATA, []);
  return (
    <div className="screen-m ef" data-screen-label="Flash · FeedbackIncorrect">
      <StatusBar/>
      <FlashTopChips/>
      <FlashProgress act={5}/>

      {/* Header soft-negative */}
      <div style={{ position: "absolute", top: 96, left: 0, right: 0, padding: "0 18px", zIndex: 4 }}>
        <div style={{
          background: "linear-gradient(180deg, rgba(255,122,140,0.14) 0%, rgba(255,122,140,0.03) 100%)",
          border: "1px solid rgba(255,122,140,0.28)",
          borderRadius: 16, padding: "16px 16px 18px"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
            <div style={{ width: 28, height: 28, borderRadius: 99, background: "rgba(255,122,140,0.18)", color: "var(--negative)", display: "grid", placeItems: "center" }}>
              <Icon name="retry" size={15}/>
            </div>
            <div className="mono" style={{ fontSize: 11, letterSpacing: "0.14em", color: "var(--negative)", textTransform: "uppercase" }}>Casi</div>
          </div>
          <div style={{ fontSize: 19, fontWeight: 600, lineHeight: 1.25, letterSpacing: "-0.01em", textWrap: "balance" }}>
            Revisa los mínimos previos: tendencia es <span style={{ color: "var(--text)" }}>secuencia</span>, no una sola vela.
          </div>
          <div style={{ fontSize: 12.5, color: "var(--text-2)", marginTop: 6, lineHeight: 1.4 }}>
            Marcaste un máximo, no un mínimo creciente.
          </div>
        </div>
      </div>

      {/* Chart highlighting correct HLs */}
      <div style={{ position: "absolute", top: 285, left: 18, right: 18 }}>
        <div className="glass" style={{ borderRadius: 14, overflow: "hidden" }}>
          <Candles data={data} width={354} height={150} padding={8}
            overlays={[
              { type: "swing", x: 3, y: data[3].l - 0.6, label: "HL" },
              { type: "swing", x: 9, y: data[9].l - 0.6, label: "HL" },
              { type: "swing", x: 16, y: data[16].l - 0.6, label: "HL" },
            ]}/>
        </div>
      </div>

      {/* Misconception detected */}
      <div style={{ position: "absolute", top: 450, left: 18, right: 18 }}>
        <div className="misconception-card">
          <div className="lbl">Misconception detectada</div>
          <div style={{ fontSize: 13.5, fontWeight: 600, marginTop: 4 }}>vela_aislada_define_tendencia</div>
          <div style={{ fontSize: 11.5, color: "var(--text-2)", marginTop: 4 }}>Una vela roja no rompe una secuencia de mínimos crecientes.</div>
        </div>
      </div>

      {/* Actions */}
      <div style={{ position: "absolute", bottom: 90, left: 18, right: 18, display: "flex", gap: 8 }}>
        <button className="btn ghost sm" style={{ flex: 1 }}><Icon name="lightbulb" size={13}/> Pista 1</button>
        <button className="btn ghost sm" style={{ flex: 1 }}><Icon name="book" size={13}/> Explica</button>
        <button className="btn primary sm" style={{ flex: 1.2 }}><Icon name="retry" size={13}/> Reintentar</button>
      </div>
      <FlashBottomRail/>
    </div>
  );
};

// ─────────────────────────────────────────────────────────
//  5. Flash / EndCard
// ─────────────────────────────────────────────────────────
export const ScreenFlashEndCard = () => {
  return (
    <div className="screen-m ef" data-screen-label="Flash · EndCard">
      <StatusBar/>
      <FlashTopChips live={false}/>

      <div style={{ position: "absolute", top: 110, left: 18, right: 18 }}>
        <Eyebrow>Has aprendido</Eyebrow>
        <div style={{ fontSize: 24, fontWeight: 600, lineHeight: 1.18, letterSpacing: "-0.02em", marginTop: 8, textWrap: "balance" }}>
          Una tendencia se reconoce por
          <span style={{ color: "var(--accent)" }}> estructura</span>, no por una vela.
        </div>
      </div>

      {/* concept evidence cautela */}
      <div style={{ position: "absolute", top: 260, left: 18, right: 18, display: "flex", flexDirection: "column", gap: 10 }}>
        {[
          { lbl: "CONCEPTO", t: "Secuencia de máximos y mínimos crecientes", icon: "graph", c: "var(--primary)" },
          { lbl: "EVIDENCIA", t: "Tres HL consecutivos en 28 sesiones", icon: "check", c: "var(--accent)" },
          { lbl: "CAUTELA", t: "Una vela roja no invalida la secuencia", icon: "shield", c: "var(--warn)" },
        ].map((c, i) => (
          <div key={i} className="glass" style={{ padding: 12, borderRadius: 12, display: "flex", gap: 10 }}>
            <div style={{
              width: 32, height: 32, borderRadius: 8,
              background: `color-mix(in oklab, ${c.c} 18%, transparent)`,
              display: "grid", placeItems: "center", flexShrink: 0
            }}>
              <Icon name={c.icon} size={14} style={{ color: c.c }}/>
            </div>
            <div>
              <div className="mono" style={{ fontSize: 9.5, letterSpacing: "0.14em", color: c.c }}>{c.lbl}</div>
              <div style={{ fontSize: 13, marginTop: 3, lineHeight: 1.3, textWrap: "pretty" }}>{c.t}</div>
            </div>
          </div>
        ))}
      </div>

      {/* recommended next */}
      <div style={{ position: "absolute", top: 490, left: 18, right: 18 }}>
        <Eyebrow>Próximo nodo</Eyebrow>
        <div className="glass" style={{ marginTop: 8, padding: 14, borderRadius: 14, border: "1px solid rgba(127,182,255,0.35)" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Chip>EXPLICA · 7 min</Chip>
            <Icon name="next" size={16} style={{ color: "var(--primary)" }}/>
          </div>
          <div style={{ fontSize: 15, fontWeight: 600, marginTop: 8, lineHeight: 1.25 }}>
            Soportes, resistencias y rupturas
          </div>
          <div style={{ fontSize: 11.5, color: "var(--text-2)", marginTop: 4 }}>4 ejercicios · 1 transferencia</div>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
          <button className="btn ghost sm" style={{ flex: 1 }}><Icon name="save" size={13}/> Guardar repaso</button>
          <button className="btn ghost sm" style={{ flex: 1 }}><Icon name="spark" size={13}/> Otro flash</button>
        </div>
      </div>

      <FlashBottomRail/>
    </div>
  );
};
